import { User } from "../@core/data/users";

export default class Like {
  id?: string;
  mode?: string;
  refId?: string;
  refTitle?: string;

  refUid?: string;
  refAuthor?: User;

  value?: boolean;

  refDescription?: string;
  refUrl?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
